import { Component, Input, OnInit } from '@angular/core';
import { SystemService } from 'projects/core/src/lib/system.service';
import { Globals } from 'projects/core/src/globals';

@Component({
  selector: 'app-importer',
  templateUrl: './importer.component.html',
  styleUrl: './importer.component.css'
})

export class ImporterComponent implements OnInit {
  
  constructor(private systemService:SystemService){}
  
  message="";
  truncateTable=false;

  ngOnInit(): void {

    if(this.addressesFields){
      this.fields=[
        {"name":"name","type":"address","label":"Nominativo anagrafica"},
        {"name":"address","type":"address","label":"Indirizzo anagrafica"},
        {"name":"city","type":"address","label":"Comune anagrafica"},
        {"name":"zip","type":"address","label":"CAP anagrafica"},
        {"name":"vat_number","type":"address","label":"Partita IVA anagrafica"},
        {"name":"tax_code","type":"address","label":"Codice fiscale anagrafica"}
      ]
    }


    this.systemService.getManifest(this.modulename).subscribe((res)=>{
      this.manifest=res;
      for(let f of this.manifest.fields){
        this.fields.push({"name":f.Field,"type":f.Type,"label":f.Label});
      }

      for(let f of this.manifest.customfields){
        this.fields.push({"name":f.label,"type":"customfield","label":f.label,"id_customfield":f.id});
      }
      
    })
  }
  
  @Input()
  table:String="";
  
  @Input()
  modulename:String="";

  @Input()
  addressesFields=true;

  file:File;
  manifest:any={};
  csv=[];
  separator=";";
  raw="";
  headers:any=[];
  fields=[];


  public onChange(event:any): void {

    Globals.loading=true;
    this.message="Caricamento file in corso...";

    let fileList: FileList=event.target.files;
    let file = fileList[0];
    let fileReader: FileReader = new FileReader();
    let self = this;

    fileReader.onloadend = function(x) {
      self.raw=null;
      if(fileReader.result!=null){
        self.raw=fileReader.result.toString();
        self.loadCSV(self.raw);
      
      }
      
    }
    fileReader.readAsText(file);
    Globals.loading=false;
    
  }


  loadCSV(raw:string){   
   
    this.headers=[];
    let rows=raw.split("\n");

    this.csv=[];
    let max_col=0;
    for(let i=0;i<rows.length;i++){
      let r=rows[i]
      r=r.replace(/"/gi,"");
      let cols=r.split(this.separator);

      if(i==0){
        for(let c of cols){
          this.headers.push({"name":c,"field":{}});
        }
        
      }else{

        this.csv.push(cols);
        if(max_col<cols.length)
          max_col=cols.length;
      }
  
    }

    this.message="Caricate "+this.csv.length+" righe con "+max_col+" colonne";    
  }
  

  startImport(){
    Globals.loading=true;
    this.message="Importazione in corso...";
    this.systemService.importData2DB(this.csv,this.headers,this.table,this.truncateTable).subscribe((ids)=>{
      this.message="Importati "+ids.length+" elementi";
      Globals.loading=false;
    });    
  }


  reset(){
    this.csv=[];
    this.headers=[];
    this.message="";
  }


}
